import { atom } from 'recoil';
import defaultComment from 'ProjectManager/Project/Introductions/Create/recoil/comment/defaultComment';

const commentAtom = atom({
    key: 'projectManagement_introduction_create_comment',
    default: defaultComment,
});

export default commentAtom;
